"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _Translations = require("react-platform-components/dist/Translations");
var _TableColumns = require("./toolbarComponents/TableColumns");
var _TableFilters = require("./toolbarComponents/TableFilters");
var _SearchField = require("./toolbarComponents/SearchField");
var _ExportCSV = require("./toolbarComponents/ExportCSV");
var _styles = require("@material-ui/core/styles");
var _config = require("../../config");
var _excluded = ["tableHeadColumns", "shownTableHeadColumns", "setShownTableHeadColumns", "appliedFilter", "setAppliedFilter", "filteredHeadColumns", "showAddRefButton", "extraOptionsButtons"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var OPERATORS = [{
  value: "ne",
  label: "n'est pas",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "n'est pas",
    defaultMessage: "n'est pas"
  })
}, {
  value: "ge",
  label: "est supérieur ou égal à",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "est sup\xE9rieur ou \xE9gal \xE0",
    defaultMessage: "est sup\xE9rieur ou \xE9gal \xE0"
  })
}, {
  value: "le",
  label: "est inférieur ou égal à",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "est inf\xE9rieur ou \xE9gal \xE0",
    defaultMessage: "est inf\xE9rieur ou \xE9gal \xE0"
  })
}, {
  value: "like",
  label: "contient",
  translation: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "contient",
    defaultMessage: "contient"
  })
}];
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    toolbar: {
      paddingTop: "1.5rem"
    },
    leftWrapper: {
      alignSelf: "flex-start",
      marginRight: "8px",
      marginBottom: "8px"
    },
    rightWrapper: {
      alignSelf: "flex-start"
    }
  };
});
var TableToolbar = (0, _Translations.injectIntl)(function (_ref) {
  var tableHeadColumns = _ref.tableHeadColumns,
    shownTableHeadColumns = _ref.shownTableHeadColumns,
    setShownTableHeadColumns = _ref.setShownTableHeadColumns,
    appliedFilter = _ref.appliedFilter,
    setAppliedFilter = _ref.setAppliedFilter,
    filteredHeadColumns = _ref.filteredHeadColumns,
    showAddRefButton = _ref.showAddRefButton,
    extraOptionsButtons = _ref.extraOptionsButtons,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyle();
  // this state is like appliedFilter but formatted in a way that is easier to use
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    formattedFilters = _useState2[0],
    setFormattedFilters = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    filters = _useState4[0],
    setFilters = _useState4[1];
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        specificities: state.specificityOfProductReducer.specificities,
        categories: state.categoryOfProductReducer.categories,
        user: state.auth.user
      };
    }),
    specificities = _useSelector.specificities,
    categories = _useSelector.categories,
    user = _useSelector.user;
  (0, _react.useEffect)(function () {
    var newFormattedFilters = formatAppliedFilters();
    var newFilters = newFormattedFilters.reduce(function (acc, filter) {
      acc[filter.columnName] = filter.filterName;
      return acc;
    }, {});
    setFormattedFilters(newFormattedFilters);
    setFilters(newFilters);
  }, [categories, specificities]);
  var formatAppliedFilters = (0, _react.useCallback)(function () {
    var formatMessage = props.intl.formatMessage;
    var filters = Object.keys(appliedFilter);
    var prefixes = OPERATORS.map(function (_ref2) {
      var value = _ref2.value;
      return value;
    });
    // we need to reformat the filters by removing the prefixes
    // so we can show the user the filters they have added
    var newFormattedFilters = filters.reduce(function (acc, filter) {
      var prefix = filter.split("_")[0];
      var filterValue = appliedFilter[filter];
      filterValue = ["true", "false"].includes(filterValue) ? formatMessage({
        id: filterValue === "true" ? "Vrai" : "Faux",
        defaultMessage: filterValue === "true" ? "Vrai" : "Faux"
      }) : filterValue;
      if (prefixes.includes(prefix)) {
        var _OPERATORS$find;
        // if the prefix is "like_" (contains), we need to remove the %
        filterValue = filterValue.replaceAll("%", "");
        var filterOperator = (_OPERATORS$find = OPERATORS.find(function (operator) {
          return operator.value === prefix;
        })) === null || _OPERATORS$find === void 0 ? void 0 : _OPERATORS$find.label;
        var name = filter.replace("_", " ").split(" ")[1];
        if (filter.includes("product_specificities")) {
          var formattedSpecificityFilter = formatSpecificityFilter(name, filterValue, filterOperator);
          if (formattedSpecificityFilter) {
            acc.push(formattedSpecificityFilter);
          }
        } else {
          var formattedColumnFilter = formatColumnFilter(name, filterValue, filterOperator);
          if (formattedColumnFilter) {
            acc.push(formattedColumnFilter);
          }
        }
      } else {
        if (filter === _config.CATEGORY_FILTER_QUERY) {
          var categoriesFiltered = Array.isArray(appliedFilter[filter]) ? appliedFilter[filter] : appliedFilter[filter].split(",");
          var categoriesNames = categoriesFiltered.map(function (categoryId) {
            var _categories$find;
            return (_categories$find = categories.find(function (category) {
              return category.id === +categoryId;
            })) === null || _categories$find === void 0 ? void 0 : _categories$find.name;
          });
          var categoriesNamesLabel = "".concat(formatMessage({
            id: "Catégories:",
            defaultMessage: "Catégories:"
          }), " ").concat(categoriesNames.join(", "));
          acc.push({
            label: categoriesNamesLabel,
            filterName: filter,
            columnName: "categories"
          });
        } else if (filter.includes("product_specificities")) {
          var _formattedSpecificityFilter = formatSpecificityFilter(filter, filterValue, "est");
          if (_formattedSpecificityFilter) {
            acc.push(_formattedSpecificityFilter);
          }
        } else {
          var _formattedColumnFilter = formatColumnFilter(filter, filterValue, "est");
          if (_formattedColumnFilter) {
            acc.push(_formattedColumnFilter);
          }
        }
      }
      return acc;
    }, []);
    return newFormattedFilters;
  }, [appliedFilter, categories, specificities]);
  var formatSpecificityFilter = (0, _react.useCallback)(function (filter, filterValue, filterOperator) {
    var _specificities$find;
    var formatMessage = props.intl.formatMessage;
    var splitFilter = filter.split("_");
    var specificityId = splitFilter[splitFilter.length - 1];
    if (!specificityId) return;
    var specificityName = (_specificities$find = specificities.find(function (specificity) {
      return specificity.id === specificityId;
    })) === null || _specificities$find === void 0 ? void 0 : _specificities$find.name;
    if (!specificityName) return;
    var filterLabel = "".concat(specificityName, " ").concat(formatMessage({
      id: filterOperator,
      defaultMessage: filterOperator
    }), " ").concat(Array.isArray(filterValue) ? filterValue.join(", ") : filterValue);
    var formattedFilter = {
      label: filterLabel,
      filterName: filter,
      columnName: specificityName
    };
    return formattedFilter;
  }, [specificities]);
  var formatColumnFilter = (0, _react.useCallback)(function (filter, filterValue, filterOperator) {
    var formatMessage = props.intl.formatMessage;
    var column = tableHeadColumns.find(function (column) {
      return column.value === filter;
    });
    if (!column) return;
    if (filter === "status") {
      var statusLabels = column.options.filter(function (_ref3) {
        var value = _ref3.value;
        return filterValue.includes(value);
      }).map(function (_ref4) {
        var label = _ref4.label;
        return formatMessage({
          id: label,
          defaultMessage: label
        });
      }).join(", ");
      filterValue = statusLabels;
    }
    var filterLabel = "".concat(formatMessage({
      id: column.label,
      defaultMessage: column.label
    }), " ").concat(formatMessage({
      id: filterOperator,
      defaultMessage: filterOperator
    }), " ").concat(filterValue);
    var formattedFilter = {
      label: filterLabel,
      filterName: filter,
      columnName: column.value
    };
    return formattedFilter;
  });
  var handleDeleteFilterButtonClick = function handleDeleteFilterButtonClick(_ref5) {
    var label = _ref5.label,
      filterName = _ref5.filterName,
      columnName = _ref5.columnName;
    var newFormattedFilters = formattedFilters.filter(function (filter) {
      return filter.label !== label;
    });
    var newAppliedFilter = _objectSpread({}, appliedFilter);
    var newFilters = _objectSpread({}, filters);
    delete newAppliedFilter[filterName];
    delete newFilters[columnName];
    setFormattedFilters(newFormattedFilters);
    setAppliedFilter(newAppliedFilter);
    setFilters(newFilters);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    className: classes.leftWrapper,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_SearchField.SearchField, {
    appliedFilter: appliedFilter,
    setAppliedFilter: setAppliedFilter
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_TableColumns.TableColumnsButton, _extends({
    appliedFilter: appliedFilter,
    setAppliedFilter: setAppliedFilter,
    shownTableHeadColumns: shownTableHeadColumns,
    setShownTableHeadColumns: setShownTableHeadColumns,
    tableHeadColumns: tableHeadColumns
  }, props))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_TableFilters.TableFiltersButton, {
    tableHeadColumns: tableHeadColumns,
    appliedFilter: appliedFilter,
    setAppliedFilter: setAppliedFilter,
    setFormattedFilters: setFormattedFilters,
    formattedFilters: formattedFilters,
    filters: filters,
    setFilters: setFilters
  })), formattedFilters.map(function (_ref6) {
    var label = _ref6.label,
      filterName = _ref6.filterName,
      columnName = _ref6.columnName;
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: label,
      item: true
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: function onClick() {
        return handleDeleteFilterButtonClick({
          label: label,
          filterName: filterName,
          columnName: columnName
        });
      },
      variant: "text",
      endIcon: /*#__PURE__*/_react.default.createElement(_core.Icon, null, "delete"),
      color: "secondary",
      title: label
    }, label.length > 20 ? label.slice(0, 20).concat("...") : label));
  }), extraOptionsButtons && extraOptionsButtons.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true
    }, item);
  })), !user.roles.some(function (item) {
    return _config.HIDE_EXPORT_CSV_BY_USER_ROLES.includes(item);
  }) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.rightWrapper
  }, /*#__PURE__*/_react.default.createElement(_ExportCSV.ExportCSV, {
    appliedFilter: appliedFilter,
    shownTableHeadColumns: shownTableHeadColumns
  }))));
});
exports.TableToolbar = TableToolbar;